// extracted by css-extract-rspack-plugin
export default {"cls1":"Timer-cls1_Ls1","cls2":"Timer-cls2_r9l Timer-cls1_Ls1","mini":"Timer-mini_DNF","darkDigits":"Timer-darkDigits_lAA"};